import { Injectable } from '@angular/core';
import { ClientDto, AssetDto } from "../data/CommandServiceDtos.generated";

@Injectable()
export class ClientAssetDataService {
  client = new ClientDto();
  asset = new AssetDto();
  filterOption: string = "active";
  projectSort = "";

  constructor() {}
}



// WEBPACK FOOTER //
// ./src/app/services/client-asset-data-service.ts